export default {
  roles: {
    status: {
      accepted: 'Accepté',
      pending: 'En attente',
      rejected: 'Refusé',
      discontinued: 'Interrompu',
    },
  },
  notifications: {
    settings: {
      missions: {
        updated: 'Mission mise à jour',
        abandoned: 'Mission abandonée',
        created: 'Mission créée',
        cancelled: 'Mission annulée',
      },
      clockings: {
        created: 'Confirmation pointage',
      },
      workersRequests: {
        completed: 'Demande complète',
        postReplaced: 'Remplacement effectué',
        created: 'Nouvelle demande',
        cancelled: 'Demande annulée',
        updated: 'Demande mise à jour',
        postNeedsReplacement: 'Remplacement demandé',
        postReOpened: 'Poste réouvert',
        postClosed: 'Poste fermé',
      },
      periodSummaries: {
        created: 'Nouvelle pré-facturation',
        cancellationRequested: 'Demande d\'annulation',
        cancellationResolved: 'Réponse à la demande d\'annulation',
      },
      workers: {
        discontinued: 'Relation interrompue avec un travailleur',
      },
    },
  },
  organizationRoles: {
    'admin': 'Admin',
    'teamLeader': "Chef d'équipe",
    'clocker': 'Pointage uniquement',
  }
}
